import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '@/router'
// 前端设备标识（React/Vue示例）
import FingerprintJS from '@fingerprintjs/fingerprintjs';
async function getDeviceId() {
    try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        return result.visitorId;
    } catch (e) {
        return `${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
    }
}
let loadingInstance
let needLoadingRequestCount = 0 // 请求计数器
function showLoading() {
    if (needLoadingRequestCount === 0) {
        loadingInstance = Loading.service({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        })
    }
    needLoadingRequestCount++
}
function hideLoading() {
    needLoadingRequestCount--
    if (needLoadingRequestCount <= 0) {
        if (loadingInstance) {
            loadingInstance.close()
        }
        needLoadingRequestCount = 0
    }
}
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 300000
})

// 缓存deviceId，避免每次请求都重新计算
let cachedDeviceId = null;
let deviceIdPromise = null;

// 初始化时就开始获取deviceId
function initDeviceId() {
    if (!deviceIdPromise) {
        deviceIdPromise = getDeviceId().then(id => {
            cachedDeviceId = id;
            return id;
        });
    }
    return deviceIdPromise;
}

// 立即开始获取deviceId
initDeviceId();

service.interceptors.request.use(
    async (config) => {
        if (!config.noLoading) { // 可通过config.noLoading跳过loading
            showLoading()
        }
        
        // 【重要】在任何异步操作之前，先同步读取token
        const token = localStorage.getItem('token')
        
        // 调试日志：检查token状态
        console.log(`[Request] ${config.method?.toUpperCase()} ${config.url} | Token: ${token ? '存在(' + token.substring(0, 20) + '...)' : '不存在'}`)
        
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        } else {
            console.warn('[Request] 警告: localStorage中没有token!')
        }
        
        // 获取deviceId（使用缓存或等待初始化完成）
        const deviceId = cachedDeviceId || await initDeviceId();
        
        config.headers['X-Device-Id'] = deviceId;
        config.headers['X-Device-Type'] = /Mobi|Android/i.test(navigator.userAgent)
            ? 'mobile'
            : 'desktop';
        config.headers['X-Device-Name'] = navigator.userAgent;
        return config
    },
    (error) => {
        hideLoading()
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        hideLoading()
        const key = `${response.config.url}&${response.config.method}`
        service.pendingMap.delete(key)

        if (response.data instanceof Blob) {
            return response.data
        }

        const res = response.data
        if (res.code !== 200) {
            Message.error(res.message || '请求失败')
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res
    },
    error => {
        hideLoading()
        let message = error.response?.data?.message || '请求失败'
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 只有在token相关错误时才清除token并跳转登录
                    const errorMsg = error.response?.data?.message || ''
                    
                    // "未提供认证令牌" 说明请求时token就不存在，可能是其他标签页已经清除了
                    // 这种情况不需要再次清除，只需要跳转登录页
                    if (errorMsg.includes('未提供认证令牌')) {
                        // 检查当前是否还有token，如果没有说明已经被其他地方清除了
                        if (!localStorage.getItem('token') && router.history.current.fullPath !== '/login') {
                            console.log('Token已被清除，跳转登录页')
                            router.push('/login')
                        }
                        break
                    }
                    
                    // 其他token错误才需要清除token
                    const tokenErrors = ['令牌已失效', '会话已过期', '令牌已过期', '令牌无效', '账号已在其他设备登录']
                    const isTokenError = tokenErrors.some(e => errorMsg.includes(e))
                    
                    if (isTokenError && router.history.current.fullPath !== '/login') {
                        console.log('Token错误，清除登录状态:', errorMsg)
                        localStorage.removeItem('token')
                        localStorage.removeItem('userInfo')
                        router.push('/login')
                    }
                    break
            }
        }
        Message.error(message)
        return Promise.reject(message)
    }
)

service.pendingMap = new Map()

export default service